import { render, staticRenderFns } from "./ClientEmailField.vue?vue&type=template&id=5f7d4bb0"
import script from "./ClientEmailField.vue?vue&type=script&lang=js"
export * from "./ClientEmailField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports